import { createIconComponent } from '../../factory/create-icon-component';
export const ArrowLeftIcon = createIconComponent(
  'ArrowLeftIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 5L3 11.9999M3 11.9999L10 18.9999M3 11.9999H21"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
